import React from 'react'
import DoubtListComponent from './components/DoubtListComponent'
import Footer from '../../components/Footer'
import HomeHeader from '../../components/HomeHeader'
import Sidebar from '../../components/SideBar'

const Doubts: React.FC = () => {
  return (
    <>
      <Sidebar />
      <HomeHeader />
      <DoubtListComponent />
      <Footer />
    </>
  )
}

export default Doubts
